// extracted by mini-css-extract-plugin
module.exports = {"root":"Signin_root__29NSi","main":"Signin_main__3LCU4","header":"Signin_header__1Rma9","mainPaper":"Signin_mainPaper__2yaX6"};